import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import DashboardWidgetWrapper from '../DashboardWidgetWrapper';
import { getProjects } from '../../../containers/Projects/projectsSlice';
import { getRoute, ROUTE_ENUMS } from '../../../helpers/routes';

// import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { Grid } from '@mui/material';

const ProjectsWidget = (props) => {
	const { t } = useTranslation('dashboard', { keyPrefix: 'widgets.projects' });
	const [projects, setProjects] = useState([]);
	const navigate = useNavigate();

	const { isLoading, results, hasBeenLoaded } = useSelector(
		(state) => state.projectsSlice.projects
	);
	const dispatch = useDispatch();

	useEffect(() => {
		if (hasBeenLoaded) {
			const newResults = [...results];

			if (newResults.length < 3) {
				const numOfBlankProjects = 3 - results.length;

				for (let x = 0; x < numOfBlankProjects; x++) {
					newResults.push({ _id: x, title: null, description: null });
				}
			}
			setProjects(newResults);
		}
	}, [hasBeenLoaded, results]);

	useEffect(() => {
		if (!hasBeenLoaded && !isLoading) {
			dispatch(getProjects());
		}
	}, []);

	const handleAddProject = () => {
		navigate(getRoute(ROUTE_ENUMS.PROJECT_CREATE), { replace: true });
	};

	const ProjectContainerAdd = () => {
		return (
			<Stack direction="row" alignItems="center" padding={4} gap={2} flex={1}>
				<Stack direction="row">
					<IconButton
						sx={{
							width: (theme) => theme.spacing(6),
							height: (theme) => theme.spacing(6),
							minWidth: 0,
							minHeight: 0,
							padding: 0,
							borderRadius: 1,
							border: '1px dashed rgba(0,0,0,.25)'
						}}
						onClick={handleAddProject}
					>
						<AddOutlinedIcon />
					</IconButton>
				</Stack>
				<Stack>
					<Typography variant="body2">{t('createNewProject')}</Typography>
					<Typography variant="caption"></Typography>
				</Stack>
			</Stack>
		);
	};

	const _renderProjectContainer = (project) => {
		const { description, title } = project;

		return (
			<Stack direction="row" alignItems="center" padding={4} gap={2} flex={1}>
				<Stack direction="row">
					<IconButton
						sx={{
							width: (theme) => theme.spacing(6),
							height: (theme) => theme.spacing(6),
							minWidth: 0,
							minHeight: 0,
							padding: 0,
							borderRadius: 1,
							border: '1px dashed rgba(0,0,0,.25)'
						}}
						disabled
					>
						<AddOutlinedIcon />
					</IconButton>
				</Stack>
				<Stack>
					<Typography variant="body2">{title}</Typography>
					<Typography
						variant="caption"
						sx={{
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							display: '-webkit-box',
							WebkitLineClamp: '1', // Limit to 2 lines
							WebkitBoxOrient: 'vertical'
						}}
					>
						{description}
					</Typography>
				</Stack>
			</Stack>
		);
	};

	const _renderProjectContainers = () => {
		return projects.map((project) => (
			<Grid direction="row" width="50%" key={project._id}>
				{_renderProjectContainer(project)}
			</Grid>
		));
	};

	return (
		<DashboardWidgetWrapper label={'Projects'}>
			<Grid container>
				<Grid direction="row" width="50%">
					<ProjectContainerAdd />
				</Grid>

				{_renderProjectContainers()}
			</Grid>
		</DashboardWidgetWrapper>
	);
};

ProjectsWidget.propTypes = {
	children: PropTypes.any,
	label: PropTypes.string
};

export default ProjectsWidget;
